import React from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {botNameSelector, closeChatbot, botTypeSelector, profileSelector, mainColourSelector} from "../chatbotSlice";
import {isDevEnv} from "../chatbotUtil";

interface WidgetHeaderProps {
    setIsClearChatHistoryModalOpen: (open: boolean) => void
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({
                                                              setIsClearChatHistoryModalOpen
                                                          }) => {

    const dispatch = useAppDispatch();
    const profile = useAppSelector(profileSelector);
    const botName = useAppSelector(botNameSelector);
    const botType = useAppSelector(botTypeSelector);
    const mainColour = useAppSelector(mainColourSelector);

    const closeWidget = () => {
        dispatch(closeChatbot())
    }

    return <div
        className={`border-b-[1px] py-3 px-4 border-opacity-10 flex h-[73px] w-full items-center justify-between text-white rounded-t-[16px]`}
        style={{backgroundColor: mainColour}}>
        <div className="flex flex-row items-center m-max py-1">
            <div
                className="w-[48px] h-[48px] rounded-full flex justify-center items-center bg-[#D9A63F]">
                <img
                    id="bot-logo"
                    itemProp="bot logo"
                    alt="Bot Logo"
                    src='/aime-assistant.png'
                    className="rounded-full text-[16px]"
                />
            </div>
            <div className="flex flex-col ml-[16px]">
                <p className="font-bold text-[16px]">Aime</p>
                <p className="font-normal text-[14px]">Online</p>
                {isDevEnv(profile) && <p className="font-normal text-[10px] text-gray-600">{botName} ({botType})</p>}
            </div>
        </div>
        <div className="flex flex-row">
            <div
                className="hover:cursor-pointer"
                onClick={() => {
                    setIsClearChatHistoryModalOpen(true);
                }}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                     className="opacity-70 hover:opacity-100">
                    <g>
                        <path
                            d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"
                            fill="white"/>
                    </g>
                </svg>
            </div>
            <div
                className="ml-[24px] hover:cursor-pointer"
                onClick={closeWidget}
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                     className="opacity-70 hover:opacity-100">
                    <line x1="0" y1="12" x2="20" y2="12" stroke="white" strokeWidth="2.5"/>
                </svg>
            </div>
        </div>
    </div>
}
